import { EUnitOfMeasure } from '../shared/enum';
import { TInputDischarge } from '../shared/iProject';
import { EUnitOfMeasureImperialLabel, EUnitOfMeasureLabel, EUnitOfMeasureMetricLabel } from './enum';

export const catchmentArea: TInputDischarge = 'catchmentArea';
export const mainChannelLength: TInputDischarge = 'mainChannelLength';
export const averageCatchmentElevation: TInputDischarge = 'averageCatchmentElevation';
export const closureSectionElevation: TInputDischarge = 'closureSectionElevation';
export const returnPeriod: TInputDischarge = 'returnPeriod';
export const parameterA: TInputDischarge = 'parameterA';
export const parameterN: TInputDischarge = 'parameterN';
export const flowConcentrationTime: TInputDischarge = 'flowConcentrationTime';
export const rainfallHeight: TInputDischarge = 'rainfallHeight';
export const curveNumber: TInputDischarge = 'curveNumber';
export const totalDischargeToBeDrained: TInputDischarge = 'totalDischargeToBeDrained';
export const dischargeType: TInputDischarge = 'dischargeType';

export const dischargePD = {
    [catchmentArea]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.squareKilometer,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.squareMile,
        },
    },
    [mainChannelLength]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.kilometer,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.mile,
        },
    },
    [averageCatchmentElevation]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.meter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.foot,
        },
    },
    [closureSectionElevation]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.meter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.foot,
        },
    },
    [returnPeriod]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureLabel.years,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureLabel.years,
        },
    },
    [parameterA]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [parameterN]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [flowConcentrationTime]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureLabel.hours,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureLabel.hours,
        },
    },
    [rainfallHeight]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.millimeter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.inch,
        },
    },
    [curveNumber]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [totalDischargeToBeDrained]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.cubicMeterPerSecond,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.cubicFootPerSecond,
        },
    },
    [dischargeType]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
};
